import { errorLogService as activityLogService } from '@/services/api/activityLog.service';
import i18n from '@/i18n';
import { sharedHelper, alertHelper } from '@/utils';
import { activityLogModel } from '@/models/api/activityLog.model';

export const state = {
    list: {
        data: [],
        pagination: {
            pageNumber: 0,
            pageSize: 0,
            lastPage: 0,
            tableRowsCount: 0
        },
    },
    status: {
        list: true,
    },
};

export const ACTIVITY_LOG_MODULE = "api/activityLog";

// ACTIONS
export const GET_ALL_ACTIVITY_LOG = 'getAllActivityLog';

// MUTATIONS
const REQUESTING = "requesting";
const ALL_ACTIVITY_LOG_SUCCESS = "allActivityLogSuccess";
const SUCCESS = "commonSuccess";
const FAILURE = "commonFailure";

export const actions = {
    [GET_ALL_ACTIVITY_LOG]({commit}, {filter}) {
        commit(REQUESTING, 'list');
        activityLogService
            .getAll(filter)
            .then((result) => {
                commit(ALL_ACTIVITY_LOG_SUCCESS, {data: result});
                commit(SUCCESS);
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
};


export const mutations = {
    [ALL_ACTIVITY_LOG_SUCCESS](state, {data}) {
        let activityLogList = data.data || [];
        state.list.data = activityLogList;
        state.list.pagination = sharedHelper.apiPaginationAdapter(data.pagination);

        if(data.success) {
            state.list.data = activityLogList.map(item => activityLogModel(item));
        }
    },
    [FAILURE](state) {
        state.status = {
            list: true,
        };
    },
    [REQUESTING](state, type) {
        state.status[type] = false;
    },
    [SUCCESS](state) {
        state.status = {
            list: true,
        };
    },
};
